import React, { memo } from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './SeatChangeTable.scss';
import { IMAGE_URL } from '../../../../constants';

const reduceParties = (data, parties) => {
  const reducedData = data.reduce((acc, item) => {
    if (!acc[item.lwan]) {
      acc[item.lwan] = {
        lwan: item.lwan,
        matched: 0,
        unmatched: 0,
      };
    }
    if (item.lwan === item.inan) {
      acc[item.lwan].matched += 1;
    } else if (
      [1, 2, 3, 4, '1', '2', '3', '4'].includes(item.lw_status) &&
      item.lwan !== item.inan
    ) {
      acc[item.lwan].unmatched += 1;
    }

    return acc;
  }, {});

  const newData = {};

  parties.forEach(item => {
    if (reducedData?.[item.an]) {
      newData[item.an] = reducedData[item.an];
    }
  });

  // eslint-disable-next-line no-restricted-syntax
  for (const party in reducedData) {
    if (!newData[party]) {
      if (!newData.OTH) {
        newData.OTH = { lwan: 'OTH', matched: 0, unmatched: 0 };
      }

      newData.OTH = {
        ...newData.OTH,
        matched: newData.OTH.matched + reducedData[party].matched,
        unmatched: newData.OTH.unmatched + reducedData[party].unmatched,
      };
    }
  }

  return newData;
};

const GainRetainTable = ({
  parties,
  logo = false,
  colorMap = {},
  gainRetain = false,
  filteredData = {},
}) => {
  const matchedUnmachedData = reduceParties(filteredData, parties);
  return (
    <div className={s.seatChangeTableWrap}>
      <div className={`${s.scTableRow} ${s.tableHead}`}>
        <div className={`${s.scTableCol}`}>Party</div>
        {gainRetain && (
          <>
            <div className={`${s.scTableCol}`}>Gain</div>
            <div className={`${s.scTableCol}`}>Retain</div>
          </>
        )}
        <div className={`${s.scTableCol}`}>Total</div>
      </div>
      {parties &&
        Array.isArray(parties) &&
        parties.length > 0 &&
        parties.map(
          party =>
            (!gainRetain || (gainRetain && party.an !== 'OTH')) && (
              <div className={`${s.scTableRow}`}>
                <div
                  className={`${s.scTableCol}`}
                  style={{
                    color:
                      party.cc ||
                      (colorMap?.[party.nm] && colorMap[party.nm].cc) ||
                      '#bcbec0',
                  }}
                >
                  {logo && (
                    <div className={s.partyLogo}>
                      <ImageV2
                        src={`${IMAGE_URL}${party.lg ||
                          (colorMap?.[party.nm] && colorMap[party.nm].lg)}.cms`}
                        alt={party.an || party.nm}
                      />
                    </div>
                  )}
                  <div
                    className={`${s.partyNameStatus} ${!logo ? s.noLogo : ''}`}
                  >
                    {party.an || party.nm}
                  </div>
                </div>
                {gainRetain && (
                  <>
                    <div
                      className={`${s.scTableCol}`}
                      style={{
                        color: '#fff',
                        background:
                          party.cc ||
                          (colorMap?.[party.nm] && colorMap[party.nm].cc) ||
                          '#bcbec0',
                      }}
                    >
                      {matchedUnmachedData?.[party.an]?.unmatched || 0}
                    </div>
                    <div
                      className={`${s.scTableCol}`}
                      style={{
                        color: '#fff',
                        background:
                          `${party.cc}7a` ||
                          (colorMap?.[party.nm] &&
                            `${colorMap[party.nm].cc}7a`) ||
                          '#bcbec0',
                      }}
                    >
                      {matchedUnmachedData?.[party.an]?.matched || 0}
                    </div>
                  </>
                )}
                <div
                  className={`${s.scTableCol}`}
                  style={{
                    color: '#fff',
                    background:
                      party.cc ||
                      (colorMap?.[party.nm] && colorMap[party.nm].cc) ||
                      '#bcbec0',
                  }}
                >
                  {(matchedUnmachedData?.[party.an]?.unmatched || 0) +
                    (matchedUnmachedData?.[party.an]?.matched || 0)}
                </div>
              </div>
            ),
        )}
    </div>
  );
};

export default memo(GainRetainTable);
